<div class="side-menu">
  @if (programSelectorContent.length > 0) {
  <sidebar-program-selector
    [class.collapsed]="!layoutService.isSidebarOpen"
    [isCollapsed]="!layoutService.isSidebarOpen"
    [programs]="programSelectorContent"
  >
  </sidebar-program-selector>
  } @if (programMenuContent.length > 0) {
  <div class="program-menu">
    @if (platformTopNavEnabled) {
    <sidebar-menu-item
      [isCollapsed]="!layoutService.isSidebarOpen"
      [count]="$safeNavigationMigration(counters?.UnreadCount)"
      [item]="notificationItem"
    >
    </sidebar-menu-item>
    } @for (item of programMenuContent; track item) {
    <sidebar-item [isCollapsed]="!layoutService.isSidebarOpen" [item]="item"> </sidebar-item>
    }
  </div>
  } @if (systemMenuContent.length > 0) {
  <div class="system-menu">
    <div class="menu-label">ADMINISTRATION</div>
    @for (item of systemMenuContent; track item) {
    <sidebar-item [isCollapsed]="!layoutService.isSidebarOpen" [item]="item"> </sidebar-item>
    }
  </div>
  } @if (!platformTopNavEnabled) {
  <div class="utils-menu">
    @for (item of utilsMenuContent; track item) {
    <sidebar-item [isCollapsed]="!layoutService.isSidebarOpen" [item]="item"> </sidebar-item>
    }
  </div>
  }
  <div class="side-menu-logo">
    <fto-logo class="logo-img" [class.logo-img--collapsed]="!layoutService.isSidebarOpen"></fto-logo>
    <a360-version [collapsed]="!layoutService.isSidebarOpen"></a360-version>
  </div>
</div>
